module.exports = __webpack_public_path__ + "img/CloudsAndRain.0957d35d.png";